<script lang="ts">
    import {exists} from 'shared/utils/custom-utils';

    export let headerFooterDivided = false;
</script>

<div class="erp-card">
    <div class="erp-card-header" class:header-divided="{headerFooterDivided}">
        <slot name="header"/>
    </div>

    <div class="erp-card-body">
        <slot name="body"/>
    </div>

    {#if exists($$slots.footer)}
        <div class="erp-card-footer" class:footer-divided="{headerFooterDivided}">
            <slot name="footer"/>
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .erp-card {
        border: 1px solid @themed-border-default;
        border-radius: @border-radius-large;
        background-color: @themed-body-bg;
        display: flex;
        flex-direction: column;

        .erp-card-header {
            padding: @spacing-m @spacing-l 0;
            display: flex;
            align-items: center;
            gap: @spacing-m;

            &.header-divided {
                border-bottom: 1px solid @themed-border-default;
                padding-bottom: @spacing-m;
            }
        }

        .erp-card-body {
            padding: @spacing-ml @spacing-l;
        }

        .erp-card-footer {
            padding: @spacing-m @spacing-l 0;
            display: flex;
            align-items: center;
            gap: @spacing-m;

            &.footer-divided {
                border-top: 1px solid @themed-border-default;
                padding-top: @spacing-m;
            }
        }
    }
</style>